;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sweetalert = require("sweetalert2");

var _sweetalert2 = _interopRequireDefault(_sweetalert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "Topup",
  data: function data() {
    return {
      invoice_id: null,
      account_id: null,
      amount: null,
      topup_url: null,
      phone: null
    };
  },

  mounted: function mounted() {
    this.topup_url = this.$attrs["topup_url"];
    this.account_id = this.$attrs["account_id"];
    this.phone = this.$attrs["msisdn"];
    this.invoice_id = this.$attrs["invoice_id"];
  },
  methods: {
    request_topup: function request_topup() {
      if (this.account_id == null || this.account_id === "") {
        _sweetalert2.default.fire({
          icon: "error",
          title: "Oops...",
          text: "It seems your agent account is not activated. Contact support for assistance"
        });
        return;
      }
      if (this.amount == null) {
        _sweetalert2.default.fire({
          icon: "error",
          title: "Oops...",
          text: "Please enter an amount !"
        });
        return;
      }
      if (this.phone == null) {
        _sweetalert2.default.fire({
          icon: "error",
          title: "Oops...",
          text: "Please enter/contact support to set your agent phone number !"
        });
        return;
      }
      if (this.amount <= 0) {
        _sweetalert2.default.fire({
          icon: "error",
          title: "Oops...",
          text: "Please enter an amount greater than 0"
        });
        return;
      }

      window.location.href = this.topup_url + "?amount=" + this.amount + "&account_id=" + this.account_id + "&msisdn=" + this.phone + "&invoice=" + this.invoice_id;
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"btn btn-primary",attrs:{"href":"#","data-toggle":"modal","data-target":"#topup-modal"}},[_vm._v("Top up")]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"topup-modal","tabindex":"-1","role":"dialog","aria-labelledby":"topup-modal","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered",attrs:{"id":"topup-modal","role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('form',{attrs:{"onsubmit":"return false;"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal-body",staticStyle:{"overflow":"auto"}},[_c('div',{staticClass:"md-form mb-5"},[_c('label',{attrs:{"data-error":"wrong","data-success":"right"}},[_vm._v("Topup Amount")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.amount),expression:"amount"}],staticClass:"form-control",attrs:{"type":"number","min":"1","placeholder":"e.g 30"},domProps:{"value":(_vm.amount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.amount=$event.target.value}}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('label',{attrs:{"data-error":"wrong","data-success":"right"}},[_vm._v("Phone Number")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone),expression:"phone"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"e.g 254.........","readonly":""},domProps:{"value":(_vm.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phone=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v("Close")]),_vm._v(" "),_c('input',{staticClass:"btn btn-primary",attrs:{"type":"button","value":"Submit"},on:{"click":_vm.request_topup}})])])])])])])}
__vue__options__.staticRenderFns = [function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v("Topup Account")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])}]
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0ed67742", __vue__options__)
  } else {
    hotAPI.reload("data-v-0ed67742", __vue__options__)
  }
})()}